import dayjs from 'dayjs'

export const isUpcoming = (date) => dayjs().isBefore(dayjs(date));
